import { render, staticRenderFns } from "./SceneOrder.vue?vue&type=template&id=3922c88f&scoped=true&"
import script from "./SceneOrder.vue?vue&type=script&lang=js&"
export * from "./SceneOrder.vue?vue&type=script&lang=js&"
import style0 from "./SceneOrder.vue?vue&type=style&index=0&id=3922c88f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922c88f",
  null
  
)

export default component.exports